"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.state = {
      open: props.open,
      transitionedIn: props.open
    };
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.closeOnEsc = _this.closeOnEsc.bind(_assertThisInitialized(_this));
    _this.closeOnNonContentClick = _this.closeOnNonContentClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keyup', this.closeOnEsc);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevState) {
      var open = this.props.open;

      if (open !== prevState.open) {
        if (open) this.openModal();else this.closeModal();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keyup', this.closeOnEsc);
      clearTimeout(this.transitionTimeout);
    }
  }, {
    key: "openModal",
    value: function openModal() {
      var _this2 = this;

      this.setState({
        open: true
      }, function () {
        _this2.transitionTimeout = setTimeout(function () {
          _this2.setState({
            transitionedIn: true
          });
        }, 0);
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this3 = this;

      this.setState({
        transitionedIn: false
      }, function () {
        _this3.transitionTimeout = setTimeout(function () {
          _this3.setState({
            open: false
          });
        }, 100);
      });
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      var onRequestClose = this.props.onRequestClose;
      var open = this.state.open;
      if (open && e.key === 'Escape') onRequestClose(e);
    }
  }, {
    key: "closeOnNonContentClick",
    value: function closeOnNonContentClick(e) {
      var onRequestClose = this.props.onRequestClose;
      if (e.target === e.currentTarget) onRequestClose(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          openState = _this$state.open,
          transitionedIn = _this$state.transitionedIn;

      var _this$props = this.props,
          classes = _this$props.classes,
          children = _this$props.children,
          openProp = _this$props.open,
          size = _this$props.size,
          onRequestClose = _this$props.onRequestClose,
          props = _objectWithoutProperties(_this$props, ["classes", "children", "open", "size", "onRequestClose"]);

      if (!openState) return null;
      return _reactDom["default"].createPortal(_react["default"].createElement("div", _extends({
        role: "presentation",
        className: (0, _classnames["default"])(classes.root, transitionedIn ? classes.visible : classes.hidden),
        onClick: this.closeOnNonContentClick
      }, props), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.content, !transitionedIn ? classes.contentOffset : null)
      }, children)), document.body);
    }
  }]);

  return Modal;
}(_react["default"].Component);

Modal.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of Modal component */
  children: _propTypes["default"].node,

  /** Bool flag to open/close the modal */
  open: _propTypes["default"].bool,

  /** Callback called when modal is closed */
  onRequestClose: _propTypes["default"].func,

  /** Size of the modal can be either 'small', 'medium' or 'large' */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large'])
};
Modal.defaultProps = {
  children: null,
  open: false,
  onRequestClose: function onRequestClose() {},
  size: 'medium'
};

var _default = (0, _withStyles["default"])(_styles["default"])(Modal);

exports["default"] = _default;